export default "/images/vendor/flag-icons/flags/4x3/tm.svg?b4446ed76be10e80da7b6bec16e7fe22";